import * as firebase from "firebase/app";
import { createContext } from "react";

const FirebaseContext = createContext((null as unknown) as typeof firebase);

export default FirebaseContext;
